export const donationLink = "https://donate.acimce.app"